/* eslint no-useless-escape: 0 */

module.exports = {
  addressFormat: 'addressLine1,addressLine2,postalCode,city',
  products: [
    {
      id: '1',
      refId: '1',
      name: 'Online',
      isShippingAddressRequired: false,
      st: 'DIGITAL',
    },
    {
      id: '2',
      refId: '2',
      name: 'Meetings',
      isShippingAddressRequired: false,
      st: 'WORKSHOP,STUDIO',
    },
    {
      id: '22',
      refId: '0',
      name: 'Virtual Group Coaching + Digital',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '23',
      refId: '0',
      name: 'Virtual Community',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'VIRTUAL_COMMUNITY',
    },
    {
      id: '24',
      refId: '0',
      name: 'Virtual Community + Workshop',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'WORKSHOP_VIRTUAL_COMMUNITY',
    },
    {
      id: '25',
      refId: '0',
      name: 'Digital360 iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '27',
      refId: '0',
      name: 'Digital360 Android',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
  ],
  validations: {
    firstName: {},
    lastName: {},
    addressLine1: {
      regex:
        "^[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€Öẞöß0-9. /\\-\\',#]*[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€Öẞöß]+[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€Öẞöß0-9. /\\-\\',#]*$",
    },
    addressLine2: {
      regex:
        "^$|^[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€Öẞöß0-9. /\\-\\',#]*[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€Öẞöß]+[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€Öẞöß0-9. /\\-\\',#]*$",
    },
    city: {
      regex:
        '^[a-zA-Z\u00C0\u00C2\u00C4\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u00DC\u0178\u00E0\u00E2\u00E4\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FC\u00FF\u00C7\u00E7\u20AC. -]*[a-zA-Z\u00C0\u00C2\u00C4\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u00DC\u0178\u00E0\u00E2\u00E4\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FC\u00FF\u00C7\u00E7\u20AC]+[a-zA-Z\u00C0\u00C2\u00C4\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u00DC\u0178\u00E0\u00E2\u00E4\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FC\u00FF\u00C7\u00E7\u20AC. -]*$',
    },
    state: {
      required: true,
    },
    postalCode: {
      type: 'string',
      min: 4,
      max: 4,
      regex: '^\\d{4}$',
      regexFlags: '',
      numbersOnly: true,
    },
    ccNumber: {
      min: 8,
      max: 20,
    },
    ccCVVNo: {},
  },
  payment: {
    modes: ['FLEX', 'CC', 'PP'],
    supportedCCs: [
      { id: 1, tid: 21, name: 'VISA', ccName: 'VISA' },
      { id: 2, tid: 22, name: 'MASTERCARD', ccName: 'MASTER CARD' },
    ],
  },
};
